import mixpanel, { Dict } from 'mixpanel-browser';
import { isProductionEnv, mixpanelToken } from 'utils/env';

export type TrackingEvent =
  | 'clear_filters'
  | 'column_visibility'
  | 'confirm_filter_selection'
  | 'copy_to_clipboard'
  | 'delay_mfa_setup'
  | 'download_report'
  | 'export_data'
  | 'exports_modal_close'
  | 'exports_modal_open'
  | 'log_in'
  | 'log_out'
  | 'open_filter_menu'
  | 'page_navigation'
  | 'page_size'
  | 'page_view'
  | 'pagination'
  | 'register_mfa'
  | 'refund_dialog_open'
  | 'refund_request'
  | 'reset_password'
  | 'reveal_auth_credentials'
  | 'search'
  | 'set_password'
  | 'tab_navigation'
  | 'time_period_select'
  | 'toggle_report_detail'
  | 'volume_view_mode_select';

export interface TrackingData extends Dict {
  name: TrackingEvent;
}

/**
 * Initialize mixpanel tracking based on environment variable
 */
export function initTracking(): void {
  if (mixpanelToken && isProductionEnv) {
    mixpanel.init(mixpanelToken);
  }
}

export function track({ name, ...properties }: TrackingData): void {
  if (isProductionEnv) {
    mixpanel.track(name, properties);
  }
}

export function identify(email: string): void {
  if (isProductionEnv) {
    mixpanel.identify(email);
    mixpanel.people.set({ $email: email });
  }
}

export function setUserProperty(properties: Dict): void {
  if (isProductionEnv) {
    mixpanel.people.set(properties);
  }
}

export function register(properties: Dict, days?: number): void {
  if (isProductionEnv) {
    mixpanel.register(properties, days);
  }
}
